<template>
    <div>
      <v-container>
          <v-toolbar elevation="0">
                    <v-icon left color="primary">mdi-currency-php-off</v-icon> Expenses  <v-divider vertical inset class="ml-5 mr-2"/>
                 
                    <v-spacer/>
                  <v-btn text small color="success"  @click="expenses={}, state='new', form=true">
                      <v-icon small left color="success">mdi-plus</v-icon>New Expenses 
                    </v-btn>
                    <v-btn text small color="info"  @click="expenses={}, state='new', acctform=true">
                      <v-icon small left color="info">mdi-plus</v-icon>Add Account
                    </v-btn>
                  
                  </v-toolbar>
       <v-row>
          <v-col cols="12">
            
          </v-col>
        
         <v-col cols="7">
                   <v-card elevation="1">
                 
                  <v-card-text  v-if="items.length">
                  <table class="va-table va-table-border-bot">
                     <tr>
                      
                       <th>Date</th>
                        <th>Category</th>
                        <th>Payee/Vendor</th>
                        <th>Amount</th>
                        <th>Created</th>
                         <th>Payment Method</th>
                        <th>Status</th>
                     </tr> 
                     <tr v-for="(item, index) in FILTEREDITEMS" :key="index">
                   
                       
                            <td> <v-icon small left  @click="expenses=item, state='modify', form=true">mdi-text-box-edit</v-icon>{{ item.date }}</td>
                            <td>{{ item.category }}</td>
                            <td>{{ item.payee_to }}</td>
                            <td>{{ $money(item.amount) }}</td>
                             <td class="text-info def-font font-italic">{{ $moment(item.created_at).fromNow()}} </td>
                              <td>{{ item.payment_method }}</td>
                            <td><v-chip  :class="STATUS_COLOR(item.status)" small>{{ item.status }}</v-chip></td>
                    </tr>
                  </table>
                 
                    <div class="pa-4">
                          <span class="mx-2">Item(s) Found: {{SEARCHFILTER.length}}</span>|
                          <span class="mx-2">
                            Rows per page: <select v-model="view.per_page" @change="view.current_page=1"  class="va-select">
                              <option v-for="fruit in [5,10,15,20,50,100,1000]" :key="fruit" :value="fruit">
                                {{ fruit }}
                              </option>
                            </select>
                          </span>
                          |
                            <span class="mx-2">
                            <v-icon left small @click="view.current_page>1?view.current_page=view.current_page-1:view.current_page=1">mdi-arrow-left</v-icon>
                            {{view.current_page}}/{{ PAGE_COUNT}}
                            <v-icon right small @click="view.current_page<PAGE_COUNT?view.current_page=view.current_page+1:view.current_page=PAGE_COUNT">mdi-arrow-right</v-icon>
                             </span>   
                    </div>
                     
                  </v-card-text>
                  <v-card-text class="text-center" v-else>
                          <div class="font-weight-thin font-italic pa-5 mt-5"  >
                            <a  @click="expenses={}, state='new', form=true">Add your first expenses...  <v-icon  right small color="primary">mdi-pencil</v-icon></a>
                          </div>
                    </v-card-text>
             
                </v-card>
             </v-col>
               <v-col cols="5">
                <v-card>
                   <v-card-text>
                    <v-icon left color="warning">mdi-text-box-multiple-outline</v-icon> Account expenses
                     <v-divider class="mt-4 mb-4"/> 
                  <table class="va-table va-table-border-bot">
                    
                     <tr v-for="(item, index) in accounts" :key="index">
                          <td class="font-weight-bold _link" @click="expenses=item, state='update', acctform=true">{{item.name}}</td>
                          <td class="font-italic">{{item.description}}</td>  
                          <td><v-chip outlined small inset :color="STATUS_COLOR(item.status)">{{item.status}}</v-chip></td>   
                    </tr>
                     </table> 
                     </v-card-text> 
                 </v-card>    
               </v-col>
       </v-row>
       </v-container>
     
         <va-expenses-form :show="form" :accounts="accounts" :data="expenses" :state="state" @DialogEvent="formEvent" />
        <va-expenses-account :show="acctform" :data="expenses" :state="state" @DialogEvent="acctEvent" />
     </div>
   </template>
   <script>
   import {
     mapMutations
   } from 'vuex'
     export default {
       data: () => ({
           form: false,
           acctform: false,
           transaction: false,
           search:"",
           selectedID:  null,
           trans_dailog: false,
           areaform: false,
           state: 'new',
           expenses:{profile:{picture:""}},
           items:[],
           accounts:[],
           view: {
              per_page: 50,
              current_page: 1,
              pagination: true
           }
       }),
       beforeCreate: function () {
         if (!this.$session.exists()) {
           this.$router.push('/')
         }
       },
       created() {
          if (this.$session.exists()) {
             this.$http.defaults.headers.common['Authorization'] = 'Bearer ' + this.$session.get('jwt')
             this.setLoggedIn(true) 
              this.CHECKPAGEPERMISSION()
             this.SETVARS()
             setTimeout(()=>{
              this.getItems()
              this.getAccounts()
             }, 300)
            
           }
       },
       computed:{
         FILTEREDITEMS(){
            if(this.items.length == 0) {
              return []
            }
            var pageArr = this.$pagination(this.SEARCHFILTER,this.view.per_page)
            return pageArr[this.view.current_page - 1]
         },
         PAGE_COUNT(){
          var pageArr = this.$pagination(this.SEARCHFILTER,this.view.per_page)
          return pageArr.length
         },
         SEARCHFILTER(){
            if(this.search != "") {
              return this.$crawler(this.items, this.search)
            } else {
              return this.items
            }
         }
       },
       methods: {
         ...mapMutations(['setAlert', 'setAlertColor', 'setAlertText', 'setLoggedIn','setVariables']),
        statusIndicator(_time) {
          //var current = this.$moment(_time)
          var a = this.$moment()
            var b = this.$moment(_time)
           var diff = a.diff(b, 'hour')
           if(diff <=  3) {
              return 'success'
           } else if(diff > 3 && diff < 5) {
               return '#A5D6A7'
           } else {
             return '#989898'
           }
      },
        imagePreview(images){
          console.log("images",images)
         if(images == null) {
          return  this.$store.state.nopreview
         }
           if(images.length == 0) {
          return  this.$store.state.nopreview
         }
         let arr = this.ViewUploadedfiles(images)
         return arr[0]
        },
        
         acctEvent(){
             this.acctform = false
             this.getAccounts()
         },
         formEvent(){
             this.form = false
             this.getItems()
         },
   
         getItems: function() { 
          this.VA_ALERT('info', 'Loading expenses data', 'progress', 100, 1500)
           this.items = []
            this.QUERY('vendors','select * from expenses order by id desc', (res)=>{
              console.log(res)
              if(res.status) {
                  this.items = res.results
              }
              
            })
        },
       getAccounts() { 
          this.VA_ALERT('info', 'Loading expenses data', 'progress', 100, 1500)
           this.accounts = []
            this.QUERY('vendors','select * from expenses_accounts order by id desc', (res)=>{
              console.log(res)
              if(res.status) {
                  this.accounts = res.results
              }
              
            })
        }
       }
     }
   </script>